import { AxiosResponse } from 'axios';
import { massBalanceApi } from '../apis';
import { MassBalance } from '../types';

export const getMassBalance = async (
  massBalanceId: string
): Promise<AxiosResponse<MassBalance>> =>
  massBalanceApi.get<MassBalance>(`/massbalance/${massBalanceId}`);
